import {
  DataLayerActions,
  DataLayerEvents,
  DataLayerFormCategories,
  DataLayerMethods,
  MoviesActivatedTypes,
  NotificationsTypes,
} from '../types/dataLayerTypes';
import { UnionServicesExIds } from '../models/Calculate';
import { ServiceIDs } from '../constants/configuration';

export const handleTopUpBalanceBankCardAnalytics = (amount: string | null) => {
  window.dataLayer = window.dataLayer || [];
  if (amount) {
    window.dataLayer.push({
      event: DataLayerEvents.TOP_UP_BALANCE,
      method: DataLayerMethods.BANK_CARD,
      value: +amount,
    });
  }
};

export const handleTopUpBalanceScratchCardAnalytics = (amount: number) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.TOP_UP_BALANCE,
    method: DataLayerMethods.SCRATCH_CARD,
    value: amount,
  });
};

export const handleServicePaymentActivateAnalytics = (
  serviceTitle: string,
  countOfMonth: number,
  servicePrice: number,
  isMoviesActivated: MoviesActivatedTypes | null,
) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.SERVICE_PAYMENT,
    action: DataLayerActions.SUCCESSFUL_PAYMENT,
    service: serviceTitle,
    numberOfMonths: countOfMonth,
    value: servicePrice,
    movies: isMoviesActivated,
  });
};

export const handleServicePaymentSuspensionAnalytics = (
  serviceTitle: string | undefined,
  countOfMonth: number,
  servicePrice: number,
) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.SERVICE_PAYMENT_PAUSE,
    action: DataLayerActions.SERVICE_PAUSE,
    service: serviceTitle,
    numberOfMonths: countOfMonth,
    value: servicePrice,
  });
};

export const handleServicePaymentAnalytics = (currentService: string, buttonName: string) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.SERVICE_PAYMENT,
    action: DataLayerActions.OPEN,
    service: currentService,
    source: buttonName,
  });
};

export const handleSuspensionAnalytics = (currentService: string) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.SERVICE_PAYMENT_PAUSE,
    action: DataLayerActions.OPEN,
    service: currentService,
  });
};

export const handleEmailSMSAnalytics = (eventType: NotificationsTypes, isChecked: boolean) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: eventType === 'sms' ? DataLayerEvents.SMS_NOTIFICATIONS : DataLayerEvents.EMAIL_NOTIFICATIONS,
    action: isChecked ? DataLayerActions.ON : DataLayerActions.OFF,
  });
};

export const handleMainBannerAnalytics = () => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.MAIN_BANNER_CLICK,
    action: DataLayerActions.OPEN_ALL_OFFERS,
  });
};

export const handleBannerAnalytics = (bannerId: number, bannerAction: string) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.BANNER_CLICK,
    action: bannerAction,
    bannerId,
  });
};

export const handleTechWorkAnalytics = (workId: number) => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.SHOW_REPAIR_WORKS,
    workId,
  });
};

export const handleTechWorkButtonAnalytics = () => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.REPAIR_WORK_BUTTON_CLICK,
    action: DataLayerActions.HURRY_UP_MASTERS,
  });
};

export const handleBrizTvShareRegistrationAnalytics = () => {
  const dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: DataLayerEvents.FORM_SUBMIT,
    formCategory: DataLayerFormCategories.BRIZ_TV_TRIAL,
    formRate: null,
    value: null,
  });
};

export const isMoviesBoughtAnalytics = (
  serviceExIds: number[] | UnionServicesExIds | undefined,
  films: boolean,
): MoviesActivatedTypes | null => {
  if (films) {
    if (serviceExIds && Array.isArray(serviceExIds)) {
      return serviceExIds.includes(ServiceIDs.Films) ? 'Yes' : 'No';
    }
    if (serviceExIds && typeof serviceExIds === 'object') {
      return serviceExIds?.iptv && serviceExIds.iptv.includes(ServiceIDs.Films) ? 'Yes' : 'No';
    }
  }
  return null;
};
